/**
 * SIMPS Drink Lab — sessionState.js
 * In-memory session state (no login, no persistent account history).
 */
window.DrinkLab = window.DrinkLab || {};

(function () {
  function createIntent() {
    return { drinkType: null, serve: undefined, tasteProfiles: [], adventure: null, sugarFreeOnly: false, spirit: undefined, intentTags: [], excludedRecipeIds: [], shownRecipeIds: [], shownHeroProductIds: [] };
  }
  function createSession() {
    return { intent: createIntent(), currentQuestionId: window.DrinkLab.QUESTION_ORDER_START, history: [], lastResult: null };
  }
  const session = createSession();

  function applyAnswer(setFields) {
    Object.keys(setFields).forEach((key) => {
      const val = setFields[key];
      if (Array.isArray(session.intent[key])) session.intent[key] = session.intent[key].concat(val);
      else session.intent[key] = val;
    });
  }
  function goTo(questionId) { session.history.push(session.currentQuestionId); session.currentQuestionId = questionId; }
  function goBack() { if (session.history.length === 0) return null; session.currentQuestionId = session.history.pop(); return session.currentQuestionId; }
  function setSugarFreeOnly(val) { session.intent.sugarFreeOnly = !!val; }
  function recordShown(recipeId, heroProductKey) {
    if (recipeId) session.intent.shownRecipeIds.push(recipeId);
    if (heroProductKey) session.intent.shownHeroProductIds.push(heroProductKey);
    session.lastResult = { recipeId, heroProductKey };
  }
  function excludeCurrentRecipe() {
    if (session.lastResult && session.lastResult.recipeId) {
      if (session.intent.excludedRecipeIds.indexOf(session.lastResult.recipeId) === -1) session.intent.excludedRecipeIds.push(session.lastResult.recipeId);
    }
  }
  function reset() { session.intent = createIntent(); session.currentQuestionId = window.DrinkLab.QUESTION_ORDER_START; session.history = []; session.lastResult = null; }

  window.DrinkLab.Session = { get: () => session, applyAnswer, goTo, goBack, setSugarFreeOnly, recordShown, excludeCurrentRecipe, reset };
})();
